<template>
  <div class="scroll-number" :class="getClass">
    <span class="scroll-number-fvalue" ref="count" v-if="$bus.isFirst" key="fvalue"></span>
    <span class="scroll-number-nfvalue" v-else key="nfvalue" :class="getFvalClass">{{ target }}</span>
    <span class="scroll-number-percent" :class="getPercentClass">{{ percent ? '%' : '' }}</span>
  </div>
</template>

<script>
import { Flip } from 'number-flip'

export default {
  props: {
    // 折扣值
    target: Number,
    // 是否需要加 `%` 符号
    percent: {
      type: Boolean,
      default: false
    },
    shopType: String
  },
  data () {
    return {
      fp: null
    }
  },
  beforeDestroy () {
    this.fp = null
  },
  computed: {
    getTarget () {
      return `${this.target}`
    },
    getClass () {
      return `scroll-number-${this.shopType}`
    },
    getPercentClass () {
      return {
        [`scroll-number-percent-${this.shopType}`]: true,
        [`scroll-number-percent-${this.shopType}-active`]: this.shopType === this.$bus.shopType && !this.$bus.isFirst
      }
    },
    getFvalClass () {
      return {
        [`scroll-number-nfvalue-${this.shopType}`]: true,
        [`scroll-number-nfvalue-${this.shopType}-active`]: this.shopType === this.$bus.shopType
      }
    }
  },
  methods: {
    init () {
      this.fp = new Flip({
        node: this.$refs.count,
        from: 99,
        duration: 2
      })
    },
    run (to) {
      this.fp && this.fp.flipTo({
        to,
        direct: false
      })
    }
  },
  watch: {
    target (current) {
      // 仅仅第一次可以滚动
      if (this.$bus.isFirst && current !== 0) {
        this.init()
        if (this.shopType === 'food') {
          this.run(current)
        } else if (this.shopType === 'fishing') {
          setTimeout(() => {
            this.run(current)
          }, 2000)
        } else if (this.shopType === 'shoot') {
          setTimeout(() => {
            this.run(current)
          }, 4000)

          setTimeout(() => {
            this.$bus.isFirst = false
            this.$bus.currentDiscount = this.$bus.discount[0]
            this.$bus.dialogCharacterTextStatus = 'welcomefood'
          }, 6200)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.scroll-number >>> .digit {
  @include px2res(font-size, 30, '!important');
  font-family: $main-font-family !important;
}

.scroll-number-food >>> .digit {
  color: #0877A2;
}

.scroll-number-fishing >>> .digit {
  color: #9A8F10;
}

.scroll-number-shoot >>> .digit {
  color: #D44D07;
}

.scroll-number {
  display: flex;

  .scroll-number-percent,
  .scroll-number-fvalue,
  .scroll-number-nfvalue {
    @include px2res(font-size, 30);
    font-family: $main-font-family;
  }

  .scroll-number-percent-food,
  .scroll-number-nfvalue-food {
    color: #0877A2;
  }

  .scroll-number-percent-fishing,
  .scroll-number-nfvalue-fishing {
    color: #9A8F10;
  }

  .scroll-number-percent-shoot,
  .scroll-number-nfvalue-shoot {
    color: #D44D07;
  }

  .scroll-number-nfvalue-food-active,
  .scroll-number-percent-food-active {
    @include text-gradient(#074C82 0%, #03253E 100%);
    filter: drop-shadow(1px 0px 0px #00FFF0) drop-shadow(-1px 0px 0px #00FFF0)
        drop-shadow(0px 1px 0px #00FFF0) drop-shadow(0px -1px 0px #00FFF0);
  }

  .scroll-number-nfvalue-fishing-active,
  .scroll-number-percent-fishing-active {
    @include text-gradient(#B44E0F 0%, #5E2608 100%);
    filter: drop-shadow(1px 0px 0px #fffc00) drop-shadow(-1px 0px 0px #fffc00)
        drop-shadow(0px 1px 0px #fffc00) drop-shadow(0px -1px 0px #fffc00);
  }

  .scroll-number-nfvalue-shoot-active,
  .scroll-number-percent-shoot-active {
    @include text-gradient(#B44E0F 0%, #5A2507 100%);
    filter: drop-shadow(1px 0px 0px #F5EA00) drop-shadow(-1px 0px 0px #F5EA00)
        drop-shadow(0px 1px 0px #F5EA00) drop-shadow(0px -1px 0px #F5EA00);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/scroll-number/index.vue